/**
 * [X.0.43] `/add-to-claude` copy + URLs, shared by ClaudeConnectorPage and the
 * Worker's crawler body so the served <title>, canonical, and no-JS text match
 * what the React page renders.
 */
export const CLAUDE_CONNECTOR_META = {
  path: '/add-to-claude',
  title: 'Add okraPDF MCP Apps to Claude',
  description:
    'Connect okraPDF to Claude with a remote MCP connector for visual PDF apps, cited regions, and two-way model context. Requires an okraPDF API key.',
  canonical: 'https://okrapdf.com/add-to-claude',
  h1: 'Add okraPDF MCP Apps to Claude.',
  subhead:
    'Add one remote MCP URL with your okraPDF API key, and Claude gets visual PDF tools: rendered pages, cited regions, and context that can flow back from the app into the conversation.',
  apiKeyNote:
    'Every okraPDF MCP tool call needs an okraPDF API key, sent as an Authorization: Bearer okra_… header. Mint one in Settings, API keys, then register the server in Claude Code with one command.',
  desktopNote:
    'In Claude Desktop, Settings, Connectors, Add custom connector has no header field: paste the URL, leave the OAuth client fields blank, and sign in with your okraPDF account when Claude asks.',
  connectorUrl: 'https://okrapdf.com/mcp',
  claudeConnectorsUrl: 'https://claude.ai/settings/connectors',
  apiKeysUrl: 'https://app.okrapdf.com/settings?tab=api-keys',
} as const;
